import { createAsyncThunk } from '@reduxjs/toolkit'
import { serializeError } from 'utils'

export const axiosThunk = thunk => async (arg, thunkAPI) => {
  try {
    const response = await thunk(arg, thunkAPI)
    return response.data
  } catch (error) {
    if (error?.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    } else {
      return thunkAPI.rejectWithValue(serializeError(error))
    }
  }
}

export const createAxiosThunk = (typePrefix, payloadCreator) =>
  createAsyncThunk(typePrefix, axiosThunk(payloadCreator))

export const noopThunk = createAsyncThunk('noop', () => null)
